import SalesRoute from './SalesRoute';

export default {
  name: 'SalesRoute',
  location: '/sales-v2',
  component: SalesRoute,
};
